module.exports = __webpack_public_path__ + "static/media/premium-account.16478a7b.png";